import { carParkRole } from '@/enum'

const capitalize = s => (s && s[0].toUpperCase() + s.slice(1)) || ''

const dateToEntryFormat = (date, field) => ({
  [`is${capitalize(field)}Used`]: date !== null,
  [field]: date
})

export const carParkDriverEntry = (driver, role, isAfterUsed, after, isBeforeUsed, before, restricted) => ({
  driver, role, isAfterUsed, after, isBeforeUsed, before, restricted
})

export const defaultCarParkDriverEntry = () => ({
  driver: '',
  role: carParkRole.DRIVER,
  isAfterUsed: false,
  after: null,
  isBeforeUsed: false,
  before: null,
  restricted: false
})

export const getDateString = (date) => date !== null ? date.toISOString().slice(0, 10) : null
export const getTimeString = (date) => date !== null ? date.toISOString().slice(11, 19) : null

export const userToParkDriverEntry = (user) => {
  const entryAfter = dateToEntryFormat(user.tripsAfter, 'after')
  const entryBefore = dateToEntryFormat(user.tripsBefore, 'before')

  return carParkDriverEntry(user.username, user.role,
    entryAfter.isAfterUsed, entryAfter.after,
    entryBefore.isBeforeUsed, entryBefore.before,
    user.restricted
  )
}
